import { render, staticRenderFns } from "./renyuan.vue?vue&type=template&id=31948a3a&scoped=true&"
import script from "./renyuan.vue?vue&type=script&lang=js&"
export * from "./renyuan.vue?vue&type=script&lang=js&"
import style0 from "./renyuan.vue?vue&type=style&index=0&id=31948a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31948a3a",
  null
  
)

export default component.exports